import React, { useState } from "react";
import type { UscDispatchType } from "../../../redux/store";
import { useUscSelector } from "../../../redux/store";
import { getLocationId } from "../../../utils/externalPriceUtils";
import { calculateExternalPrice, setUserTaxLocation } from "../../../redux/actions/UscExternalPriceActions";
import useFuseFilter from "../../../../../common-deprecated/hooks/useFuseFilter";
import Combobox from "../styles/molecules/forms/Combobox";
import Icon from "../styles/Icon";
import Inputgroup from "../styles/molecules/forms/Inputgroup";
import type { UscTrackingLocation } from "../../../utils/tracking";
import { trackCalculateTaxes } from "../../../utils/tracking";
import { useDispatch } from "../../../../../shared-logic/redux/store";

type TaxLocationSearchType = { trackingLocation: UscTrackingLocation; onClose: () => void };
const TaxLocationSearch = ({ trackingLocation, onClose }: TaxLocationSearchType): JSX.Element => {
    const dispatch = useDispatch<UscDispatchType>();
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [searchActive, setSearchActive] = useState<boolean>(false);
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const taxLocations = useUscSelector((state) => state.uscSettings.taxLocations);
    const currentTaxLocation = useUscSelector(({ uscSettings, externalPrice, dealer }) =>
        uscSettings.taxLocations.find(
            (location) => location.id === getLocationId(dealer.dealer, externalPrice.userTaxLocationId),
        ),
    );

    // Reuse the Fuse filter initially developed for car-filter brand/model search.
    // If there is ever feedback on some searches not appearing (or too many searches appearing) consider tweaking the treshold.
    const filteredLocationIds = useFuseFilter(searchQuery, taxLocations, 0.25);
    const renderedLocations = searchActive
        ? taxLocations.filter((taxLocation) => filteredLocationIds.includes(taxLocation.id))
        : taxLocations;

    const box = (
        <Inputgroup variant="default" iconAppend={<Icon variant="search" />}>
            <input
                type="text"
                value={searchQuery}
                placeholder={currentTaxLocation?.label || ""}
                role="combobox"
                aria-controls="tax-location-search"
                aria-expanded="true"
                onChange={(event) => {
                    setSearchQuery(event.target.value);
                    // Only "activate" search if there are at least 2 characters.
                    setSearchActive(event.target.value.length > 1);
                }}
            />
        </Inputgroup>
    );

    const list = (
        <>
            {renderedLocations.map((location) => {
                return (
                    <li key={location.id}>
                        <button
                            type="button"
                            onClick={(event) => {
                                event.preventDefault();
                                dispatch(setUserTaxLocation(location.id));
                                dispatch(calculateExternalPrice());
                                trackCalculateTaxes(vehicleType, trackingLocation, location.label);
                                onClose();
                            }}
                        >
                            {location.label}
                        </button>
                    </li>
                );
            })}
        </>
    );

    return <Combobox variant="default" box={box} list={list} id="tax-location-search" />;
};

export default TaxLocationSearch;
